import { QrStream } from 'vue3-qr-reader';
export default {
  // 注册
  components: {
    QrStream
  },
  data() {
    return {
      error: '',
      //错误信息
      result: ''
    };
  },
  methods: {
    onDecode(result) {
      window.location.href = result;
    },
    async onInit(promise) {
      try {
        const {
          capabilities
        } = await promise;
        const TORCH_IS_SUPPORTED = !!capabilities.torch;
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = 'ERROR: 您需要授予相机访问权限';
        } else if (error.name === 'NotFoundError') {
          this.error = 'ERROR: 这个设备上没有摄像头';
        } else if (error.name === 'NotSupportedError') {
          this.error = 'ERROR: 所需的安全上下文(HTTPS、本地主机)';
        } else if (error.name === 'NotReadableError') {
          this.error = 'ERROR: 相机被占用';
        } else if (error.name === 'OverconstrainedError') {
          this.error = 'ERROR: 安装摄像头不合适';
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = 'ERROR: 此浏览器不支持流API';
        }
        console.log(error);
        alert(this.error);
      }
    }
  }
};